'use client'

import { Sitemap, SitemapProps } from '@/screens/Sitemap'

type Props = SitemapProps

const SitemapPageContent = (props: Props) => {
	const { catalogSections, pageSections, brands, used, markdowns, seolinks, services } = props

	return (
		<>
			<Sitemap
				catalogSections={catalogSections}
				pageSections={pageSections}
				brands={brands}
				used={used}
				markdowns={markdowns}
				seolinks={seolinks}
				services={services}
			/>
		</>
	)
}

export function SitemapClient(props: Props) {
	return <SitemapPageContent {...props} />
}
